import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import UserSettingsWrapper from './UserSettingsWrapper';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	userId: string;
}

const UserSettingsWrapperModal: React.FC<Props> = props => (
	<BaseModal {...props} title='base.settings' size={Size.MD}>
		<UserSettingsWrapper userId={props.userId} onClose={props.onClose} />
	</BaseModal>
);

export default UserSettingsWrapperModal;
